/*    
<summary>
   This functional common component provides protected routing.
   Developer:Aashish Singh, Created Date:08-Mar-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { FC } from 'react';
import { Route } from 'react-router-dom';
import Layout from '../Layout/Layout';
import AuthProvider from '../../contexts/AuthProvider';
import InactivityPopup from '../popup/inactivity-popup/inactivity-popup';
import config from '../../helpers/config-helper';

const appConfig = config();
const idelTimeoutEnabled = appConfig.IDLE_TIMEOUT_ENABLED;

const LayoutRoute: FC<any> = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => (
      <Layout>
        <AuthProvider>
          { idelTimeoutEnabled &&
            <InactivityPopup />
          }
          <Component {...matchProps} />
        </AuthProvider>
      </Layout>
    )} />
  )
};

export default LayoutRoute;  